<template>
  <div class="continer">
    <div class="header">
      <!-- 返回 -->
      <div class="back" @click="goBack()">
        <img src="@/assets/images/daily_task/close.png" alt="" srcset="" />
      </div>
      <!-- 标题 -->
      <div class="title">玩法说明</div>
    </div>
    <div class="main">
      <div class="top">
        <div class="tab">
          <div
            class="item"
            :class="{ active: rankingType == 'daily' }"
            @click="changeRankingType('daily')"
          >
            日榜玩法
          </div>
          <div
            class="item"
            :class="{ active: rankingType == 'weekly' }"
            @click="changeRankingType('weekly')"
          >
            周榜玩法
          </div>
        </div>
        <div class="desc">{{ awardGiveTime }}</div>
      </div>
      <div class="table">
        <div class="item head">
          <div>排名</div>
          <div>奖励</div>
        </div>
        <div class="item" v-for="(item, index) in pageData.list" :key="index">
          <div>{{ item.title }}</div>
          <div>{{ item.reward_money }}</div>
        </div>
      </div>
      <div class="describe">
        <div class="describe-inner" v-html="pageData.describe"></div>
      </div>
    </div>
    <!-- loading -->
    <loading :isLoad="isLoading"></loading>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Empty, Popup } from 'vant'
import Loading from '@/components/Loading'

Vue.use(Toast)
  .use(Empty)
  .use(Popup)

export default {
  name: 'Rule',
  components: {
    Loading,
  },
  data() {
    return {
      // 用户信息
      userId: '',
      deviceId: '',
      appVersion: '',
      // 当前活动id
      currentRankId: '',
      // 加载状态
      isLoading: false,
      pageData: {
        list: [
          {
            title: '-',
            reward_money: '-',
          },
        ],
        describe:
          '<p>\r\n 1.活动时间xx月xx日--xx月xx日；\r\n</p>\r\n<p>\r\n    2.周期内玩家累计获得的任务金额进行排名（实时更新）前xx名将得到额外的现金奖励；\r\n</p>\r\n<p>\r\n    3.活动包含【赚钱列表-游戏和应用】分类里的所有任务；\r\n</p>\r\n<p>\r\n    4.新手等收益加成部分的金额不计入；\r\n</p>\r\n<p>\r\n    5.本赏金赛排名实时更新，若任务金额相同，先到达此金额的排名优先；\r\n</p>\r\n<p>\r\n    6.活动奖励将于结束后的第二天发放，节假日顺延，可在【我的-余额明细】中查看；\r\n</p>\r\n<p>\r\n    7.累计领取的任务金额在周期内最后一天的24:00截止，若因审核或是游戏商家接口延迟未能在期限内领取，这部分奖励将不计算在内，但可累加到下一期；\r\n</p>\r\n<p>\r\n    8.本活动最终解释权归本平台所有\r\n</p>',
      },
      // 榜单类型
      rankingType: 'daily',
      // 缓存数据
      cacheData: {},
    }
  },
  computed: {
    // 发奖时间
    awardGiveTime() {
      if (this.rankingType == 'daily') {
        return '奖励将于每日凌晨0:05自动发放至余额'
      } else {
        return '奖励将于每周一10点审核后发放至余额'
      }
    },
  },
  created() {
    this.userId = this.getCookie('userid')
    this.deviceId = this.getCookie('device_id')
    this.appVersion = this.getCookie('app_version')
    if (!this.userId) {
      this.userId = this.$route.query.user_id
      this.deviceId = this.$route.query.device_id
      this.appVersion = this.$route.query.app_version
    }
    this.getPageData()
  },
  methods: {
    getCookie: function(name) {
      var strcookie = document.cookie //获取cookie字符串
      var arrcookie = strcookie.split('; ') //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split('=')
        if (arr[0] == name) {
          return arr[1]
        }
      }
      return ''
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval ? fval : {}
        let params = { method: fname, params: fval }
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    // 切换榜单类型
    changeRankingType(type) {
      if (!type || this.rankingType == type) {
        return
      }
      this.rankingType = type
      this.getPageData()
    },
    // 获取页面数据
    getPageData() {
      // 读取缓存
      if (this.cacheData.hasOwnProperty(this.rankingType)) {
        this.setItem(this.cacheData[this.rankingType])
        return
      }
      const params = {
        userid: this.userId,
        device_id: this.deviceId,
        // app_version: this.appVersion,
        activity_type: 1, // 1:周榜 3:日榜
      }
      this.isLoading = true
      // 日榜|周榜 数据
      if (this.rankingType == 'daily') {
        params.activity_type = 3
      }
      // 传入id
      if (this.currentRankId != '') {
        params.activity_id = this.currentRankId
      }
      this.$http
        .get('/api/user_web/show_activity_by_type', { params: params })
        .then((res) => {
          // 设置数据
          this.setItem(res.data.list)
          this.isLoading = false
          // 加入缓存
          this.$set(this.cacheData, this.rankingType, res.data.list)
        })
    },
    setItem(config) {
      Object.keys(config).forEach((key) => {
        switch (true) {
          // 试玩排名说明
          case config[key].itemCategory == 'item_top':
            this.pageData.list = config[key].item_list
            break
          // 奖励规则说明
          case config[key].itemCategory == 'item_text':
            this.pageData.describe = this.htmlspecialcharsDecode(
              config[key].text
            )
            break
        }
      })
    },
    htmlspecialcharsDecode: function(str) {
      var s = ''
      if (str.length == 0) return ''
      s = str.replace(/&amp;/g, '&')
      s = s.replace(/&lt;/g, '<')
      s = s.replace(/&gt;/g, '>')
      s = s.replace(/&nbsp;/g, ' ')
      return s
    },
  },
}
</script>

<style lang="less" scoped>
.continer {
  max-width: inherit;
  font-family: PingFangSC-Medium;
  position: relative;
  background: #ffffff;
  min-height: 100vh;
}

.header {
  display: flex;
  align-items: center;
  height: 0.44rem;
  padding: 0.3rem 0 0.2rem 0;
  position: relative;

  .back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.44rem;
    height: 0.33rem;
    position: absolute;
    // top: 0.3rem;
    left: 0;
    z-index: 999;

    img {
      width: 0.14rem;
    }
  }

  .title {
    flex: 1;
    display: flex;
    justify-content: center;
    font-size: 0.18rem;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.18rem;
    font-weight: 500;
  }
}

.main {
  margin: 0 0.12rem;
  padding-bottom: 0.24rem;
  margin-bottom: 0.2rem;
  background: #fff7f5;
  border-radius: 0.12rem;
  overflow: hidden;

  .top {
    .tab {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      background: #ffa2a1;
      // border-radius: 0.12rem 0.12rem 0 0;

      .item {
        height: 0.46rem;
        line-height: 0.46rem;
        font-size: 0.16rem;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 600;
      }

      .item.active {
        opacity: 1;
        background-image: linear-gradient(270deg, #ff1f27 0%, #ff8e3f 100%);
        border-radius: 12px 12px 0 0;
      }
    }

    .desc {
      padding: 0.16rem 0;
      font-size: 0.14rem;
      color: #ad0e1b;
      text-align: center;
      text-shadow: 0 0.01rem 0 rgba(255, 255, 255, 0.6);
    }
  }

  .table {
    margin: 0 0.04rem;
    background: #ffffff;
    border-radius: 0 0 0.1rem 0.1rem;

    .item {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      height: 0.38rem;
      padding: 0 0.24rem;
      border-bottom: 0.02rem solid #fff7f5;

      div {
        font-size: 0.16rem;
        color: #333333;
        letter-spacing: 0;

        &:first-child {
          text-align: left;
        }

        &:last-child {
          text-align: right;
        }
      }

      // 选择前2-4个
      &:nth-child(n + 2):nth-child(-n + 4) div {
        color: #ff2929;
      }
    }

    .item.head {
      background: #ffe4ae;
      border-radius: 0.1rem 0.1rem 0 0;

      div {
        font-size: 0.14rem;
        color: #333333;
        font-weight: 500;
      }
    }
  }

  .describe {
    margin: 0.16rem 0.26rem;
    margin-bottom: 0;

    .describe-inner {
      font-size: 0.14rem;
      color: #666666;
      text-align: justify;
      line-height: 0.2rem;
    }
  }
}
</style>
